import { useEffect, useRef } from "react";
import { MicOff, UserX, VideoOff, Mic } from "lucide-react";

function Media({ track, kind, muted, testid, className }) {
  const el = useRef(null);
  useEffect(() => {
    if (el.current) el.current.srcObject = track ? new MediaStream([track]) : null;
  }, [track]);
  if (kind === "audio") return <audio ref={el} autoPlay playsInline data-testid={testid} />;
  return <video ref={el} autoPlay playsInline muted={muted} data-testid={testid} className={className} />;
}

const playable = (t) => t && t.state === "playable" ? t.persistentTrack : null;

export const ParticipantTile = ({ p, isHost, onMute, onRemove, screen = false }) => {
  const video = playable(screen ? p.tracks?.screenVideo : p.tracks?.video);
  const audio = !p.local && !screen ? playable(p.tracks?.audio) : null;
  const micOn = p.tracks?.audio?.state === "playable";
  const id = `${p.session_id}${screen ? "-screen" : ""}`;
  return (
    <div className="relative aspect-video rounded-2xl overflow-hidden bg-[#1A242B]" data-testid={`studio-tile-${id}`}>
      {video ? <Media track={video} kind="video" muted className={`w-full h-full ${screen ? "object-contain" : "object-cover"} ${p.local && !screen ? "-scale-x-100" : ""}`} testid={`studio-video-${id}`} />
        : <div className="w-full h-full grid place-items-center text-white/60"><VideoOff size={28} /></div>}
      {audio && <Media track={audio} kind="audio" testid={`studio-audio-${id}`} />}
      <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between gap-2">
        <span className="text-xs text-white bg-black/50 rounded-full px-2.5 py-1 inline-flex items-center gap-1">
          {!screen && (micOn ? <Mic size={11} /> : <MicOff size={11} />)}
          {p.user_name || "Guest"}{p.local ? " (you)" : ""}{screen ? " · screen" : ""}{p.owner ? " · host" : ""}
        </span>
        {isHost && !p.local && !screen && (
          <span className="flex gap-1">
            <button onClick={() => onMute(p)} aria-label={`Mute ${p.user_name}`} data-testid={`studio-mute-${p.session_id}`} className="bg-black/50 text-white rounded-full p-1.5 hover:bg-black/70"><MicOff size={13} /></button>
            <button onClick={() => onRemove(p)} aria-label={`Remove ${p.user_name}`} data-testid={`studio-remove-${p.session_id}`} className="bg-black/50 text-white rounded-full p-1.5 hover:bg-red-600"><UserX size={13} /></button>
          </span>
        )}
      </div>
    </div>
  );
};
